<template>
	<div class="top-divider pt-2">
		<v-row no-gutters>
			<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pr-2' : ''" cols="12" md="6">
				<div>
					{{ productName() }}
				</div>
				<div>個数：{{ quantity() }}</div>
				<v-text-field
					label="施工場所"
					v-model="constructionPlace"
					class="mt-4"
					outlined
					dense
					hint="施工場所を設定すると全ての枝番号に反映されます。"
					persistent-hint
					@blur="setConstructionPlace"
				/>

				<v-select
					label="製品の分け方"
					:items="divisionOptions"
					v-model="division"
					item-value="id"
					item-text="name"
					outlined
					dense
					:rules="formType == 'edit' ? [] : [rules.required]"
					@change="changeOption"
					class="mt-4"
				/>

				<template v-if="division != 'not_divide'">
					<v-select
						label="枝番号の付け方"
						:items="branchNumberOptions"
						v-model="branchNumber"
						item-value="id"
						item-text="name"
						outlined
						dense
						:rules="formType == 'edit' ? [] : [rules.required]"
						@change="changeOption"
						class="mt-4"
					/>
					<template v-if="division == 'divide_by_number'">
						<v-text-field
							label="分割する数"
							v-model="divideByNumber"
							class="mt-4"
							type="number"
							hide-spin-buttons
							step="1"
							outlined
							dense
							:rules="[rules.required, rules.integer]"
							@blur="setDivideByNumber"
						/>
					</template>
					<template v-else-if="division == 'divide_into_number'">
						<v-text-field
							label="指定する数量"
							v-model="divideIntoNumber"
							class="mt-4"
							type="number"
							hide-spin-buttons
							step="1"
							outlined
							dense
							:rules="[rules.required, rules.integer]"
							@blur="setDivideIntoNumber"
						/>
					</template>
				</template>
			</v-col>
			<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pl-2' : ''" cols="12" md="6">
				<template v-if="orderIndividualInfos.length">
					<v-row no-gutters justify="space-between">
						<h6 class="text-body-1 font-weight-bold">枝番号と個数の設定</h6>
						<v-btn color="secondary" @click="addIndividualInfo">
							<v-icon class="mr-1">mdi-plus</v-icon>
							追加
						</v-btn>
					</v-row>
					<div v-for="(orderIndividualInfo, i) in orderIndividualInfos" :key="i" class="mt-4">
						<v-row no-gutters justify="space-between">
							<v-col cols="6" class="px-1">
								<v-text-field
									label="枝番号"
									v-model="orderIndividualInfo.sub_number"
									type="number"
									hide-spin-buttons
									step="1"
									outlined
									dense
									:rules="[rules.required, rules.integer]"
								>
									<template v-slot:prepend>
										<h6 class="text-body-1 font-weight-bold">{{ i + 1 }}.</h6>
									</template>
								</v-text-field>
							</v-col>
							<v-col cols="6" class="px-1">
								<v-text-field
									label="個数"
									v-model="orderIndividualInfo.quantity"
									type="number"
									hide-spin-buttons
									step="1"
									outlined
									dense
									class="append-outer"
									:rules="[rules.required, rules.integer, quantityAmountCheck]"
								>
									<template v-slot:append-outer>
										<v-menu v-if="orderIndividualInfo.id" top>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													v-bind="attrs"
													v-on="on"
													color="red"
													:disabled="orderIndividualInfos.length < 2"
													class="mt-0"
													><v-icon>mdi-close-circle-outline</v-icon></v-btn
												>
											</template>
											<v-card class="top-border pa-2 pt-4">
												<p>
													データに関連する依頼や物流情報がある場合は、不具合が生じる場合があります。
												</p>
												<v-row justify="center" no-gutters class="mt-4">
													<v-btn color="red" dark @click="removeIndividualInfo(i)">
														<v-icon class="mr-1">mdi-delete</v-icon>
														削除
													</v-btn>
												</v-row>
											</v-card>
										</v-menu>
										<v-btn
											v-else
											icon
											@click="removeIndividualInfo(i)"
											color="red"
											:disabled="orderIndividualInfos.length < 2"
											class="mt-0"
											><v-icon>mdi-close-circle-outline</v-icon></v-btn
										>
									</template>
								</v-text-field>
							</v-col>
						</v-row>
					</div>
					<p class="text-right">合計: {{ quantityAmount }}</p>
				</template>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		matter_product: {
			type: Object,
		},
		ordered_product: {
			type: Object,
		},
		order_individual_infos: {
			type: Array,
			required: true,
		},
		deleted_ids: {
			type: Array,
			required: false,
			default: () => [],
		},
		formType: {
			type: String,
			required: false,
			default: "new",
		},
	},
	data() {
		return {
			divideByNumber: null,
			divideIntoNumber: null,
			branchNumber: null,
			division: null,
			constructionPlace: null,
			divisionOptions: [
				{ id: "not_divide", name: "分けない" },
				{ id: "divide_by_number", name: "分割数を指定する" },
				{ id: "divide_into_number", name: "数量を指定して分割する" },
				{ id: "original", name: "自身で設定する" },
			],
			branchNumberOptions: [
				{ id: "auto", name: "1から順番で自動で設定する" },
				{ id: "original", name: "自身で設定する" },
			],
			rules: rules,
		}
	},
	methods: {
		changeOption() {
			this.orderIndividualInfos = []
			switch (this.division) {
				case "not_divide":
					this.orderIndividualInfos = [
						{
							sub_number: 1,
							quantity: this.quantity(),
							...this.setProductId(),
						},
					]
					break
				case "divide_by_number":
					this.divideIntoNumber = null
					if (this.divideByNumber) this.setDivideByNumber()
					break
				case "divide_into_number":
					this.divideByNumber = null
					if (this.divideIntoNumber) this.setDivideIntoNumber()
					break
				case "original":
					this.orderIndividualInfos = [
						{
							sub_number: this.branchNumber == "auto" ? 1 : null,
							quantity: null,
							...this.setProductId(),
						},
					]
					break
			}
		},
		setDivideByNumber() {
			const result = Math.floor(this.quantity() / parseInt(this.divideByNumber))
			const remainder = this.quantity() % parseInt(this.divideByNumber)
			this.orderIndividualInfos = [...Array(Number(this.divideByNumber))].map((_, i) => ({
				sub_number: this.setSubNumber(i),
				quantity: i < remainder ? result + 1 : result,
				...this.setProductId(),
			}))
		},
		setDivideIntoNumber() {
			const result = Math.floor(this.quantity() / parseInt(this.divideIntoNumber))
			const remainder = this.quantity() % parseInt(this.divideIntoNumber)
			this.orderIndividualInfos = [...Array(remainder == 0 ? result : result + 1)].map((_, i) => ({
				sub_number: this.setSubNumber(i),
				quantity: i == result ? remainder : parseInt(this.divideIntoNumber),
				...this.setProductId(),
			}))
		},
		addIndividualInfo() {
			const sub_number =
				this.orderIndividualInfos[this.orderIndividualInfos.length - 1]?.sub_number || 0
			this.orderIndividualInfos.push({
				sub_number: this.setSubNumber(sub_number),
				quantity: null,
				...this.setProductId(),
			})
		},
		removeIndividualInfo(i) {
			const individualInfo = this.orderIndividualInfos[i]
			if (individualInfo.id) this.deletedIds.push(individualInfo.id)
			this.orderIndividualInfos.splice(i, 1)
		},
		setConstructionPlace() {
			this.orderIndividualInfos.forEach((o) => {
				o.constructionPlace = this.constructionPlace
			})
		},
		setSubNumber(i) {
			if (this.branchNumber == "auto") {
				return i + 1
			} else if (this.branchNumber == "original") {
				return null
			}
		},
		setProductId() {
			if (this.ordered_product) {
				return {
					ordered_product_id: this.ordered_product.id,
					construction_place: this.constructionPlace,
				}
			} else if (this.matter_product) {
				return {
					matter_product_id: this.matter_product.id,
					construction_place: this.constructionPlace,
				}
			}
		},
		quantity() {
			if (this.ordered_product) {
				return this.ordered_product.quantity
			} else if (this.matter_product) {
				return this.matter_product.quantity
			}
		},
		productName() {
			if (this.ordered_product) {
				return `${this.ordered_product.product.name} ${
					this.ordered_product.sub_name ? this.ordered_product.sub_name : ""
				}`
			} else if (this.matter_product) {
				return `${this.matter_product.product.name} ${
					this.matter_product.sub_name ? this.matter_product.sub_name : ""
				}`
			}
		},
	},
	computed: {
		quantityAmountCheck() {
			const amount = this.orderIndividualInfos.reduce(
				(preVal, newVal) =>
					preVal + (isNaN(parseInt(newVal.quantity)) ? 0 : parseInt(newVal.quantity)),
				0
			)
			if (amount != this.quantity()) return "合計個数が一致しません。"
			return true
		},
		quantityAmount() {
			const amount = this.orderIndividualInfos.reduce(
				(preVal, newVal) =>
					preVal + (isNaN(parseInt(newVal.quantity)) ? 0 : parseInt(newVal.quantity)),
				0
			)
			return amount
		},
		orderIndividualInfos: {
			get() {
				return this.order_individual_infos
			},
			set(newVal) {
				return this.$emit("update:order_individual_infos", newVal)
			},
		},
		deletedIds: {
			get() {
				return this.deleted_ids
			},
			set(newVal) {
				return this.$emit("update:deleted_ids", newVal)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

.top-border {
	border-top: 8px solid $sub-color;
}
</style>